<div class="tax-title">Tax withholding elections
    <mm-tooltip *ngIf="isNraAccount" [position]="'right'" [containsLink]="false"
    id="tax-withholding-tooltip" data-testid="accountInfoHeader_taxWithholdingTooltip">
    <tooltip-content>
        <div>{{tooltipVerbiage}}</div>
    </tooltip-content>
    <tooltip-trigger-element>
        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
    </tooltip-trigger-element>
</mm-tooltip>
</div>

<div class="tax-percentage-container">
    <div class="tax-percentage"  >Federal: {{ federalTaxRate }}  State{{stateCodeLabel}}: {{ stateTaxRate }}</div>
</div>
